import { render, staticRenderFns } from "./charts-list-panel.vue?vue&type=template&id=0f0e5d24"
import script from "./charts-list-panel.vue?vue&type=script&lang=ts"
export * from "./charts-list-panel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports